"use client";

import { useEffect, useState } from 'react'
import styles from "@/styles/home/csotd.module.scss";
import Image from "next/image";
import { Timer } from '@/utils/countDown'
import { Skeleton } from 'react-vant';
import homeApi from '@/service/modules/homeApi'
import useCartActions from '@/utils/addTocartAction'
import type { paymentInfoType } from "@/types/cartProduct";
import { toast } from "@/components/global/Toast";
import type { CrazyDealDataType } from "@/types/csotd";

interface Props {
  setPageDate?: (res: paymentInfoType) => void;
}

export default function Bdotd({setPageDate}: Props) {
  const { addToCart } = useCartActions();

  // 获取CrazyDeal数据
  const [crazyDealData, setCrazyDealData] = useState<CrazyDealDataType | null>(null);

  const getCrazyDealData = async () => {
    try {
      const { data } = await homeApi.getCsotd()
      if (!data.product) return
      const productData = {
        productID: data.product.productID,
        name: data.product.name,
        url: data.product.url,
        filename: data.product.filename,
        price: data.product.price,
        normalPrice: data.product.normalPrice,
        promotion: data.product.promotion,
        crazyDeal: data.product.crazyDeal,
      }
      setCrazyDealData(productData)
    } catch {
      return { notFound: true };
    }
  };

  useEffect(() => {
    getCrazyDealData();
  }, []);

  const timer = new Timer()
  interface TimeRemaining {
    days: number | string,
    hours: string,
    minutes: string,
    seconds: string,
    isEnd: boolean,
  }

  const [timeDetail, setTimeDetail] = useState<string[]>([])
  const [priceArr, setPrice] = useState(['', ''])

  useEffect(() => {
    if (crazyDealData && crazyDealData.crazyDeal) {
      const { hoursLeft, minutesLeft, secondsLeft } = crazyDealData.crazyDeal
      // 结束时间
      const time = new Date().getTime() + (60 * 60 * hoursLeft + 60 * minutesLeft + secondsLeft) * 1000
      countDown(time)

      // 价格拆分
      setPrice(String(crazyDealData.price).split('.'))
      return () => {
        timer.timerSwitch = false
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crazyDealData])

  function countDown(times: Date | number) {
    timer.countDown(times, (timeRemaining: TimeRemaining) => {
      if (timeRemaining.isEnd) { // 倒计时结束了
        location.reload()
      } else { // 正在倒计时
        let timeDetail: string[] = []
        const { days, hours, minutes, seconds, isEnd } = timeRemaining
        if (isEnd) return
        let hh: string | number = Number(days) * 24 + parseInt(hours)
        if (hh <= 99) {
          hh = hh < 10 ? '0' + hh : `${hh}`
          const [h1, h2] = hh.split('')
          timeDetail.push(h1, h2)
        } else {
          timeDetail.push('9', '9')
        }
        const [m1, m2] = minutes.split('')
        const [s1, s2] = seconds.split('')
        timeDetail = [...timeDetail, m1, m2, s1, s2]
        setTimeDetail(timeDetail)
      }
    })
  }

  const handleViewDetail = (url: string) => {
    window.location.href = url
  };

  // 加购
  const handleGrabNow = (event: React.MouseEvent<HTMLElement>) => {
    addToCart(event, { productID: crazyDealData.productID, qty: 1 }, addToCartCallBack)
  };

  const addToCartCallBack = (response: paymentInfoType | "error") => {
    if (response != "error") {
      successAddCart(response)
      toast.show("Add to cart successfully!")
    }
  }

  // 更新购物车列表
  const successAddCart = (res: paymentInfoType) => {
    if (setPageDate) {
      setPageDate(res);
    }
  };

  return (
    <div className={styles["comp-csotd"]} style={{ background: `url('${process.env.IMAGE_DOMAIN}/home/BestDealoftheDay-bg.png') no-repeat`, backgroundSize: 'cover'}}>
      {crazyDealData?.name ? (
        <div className={styles["content"]}>
        <div className={styles["content-left"]}>
          <div className={styles["title"]}>Best Deal of the Day</div>

          <div className={styles["count-down-box"]}>
            <Image
              className={styles["clock-image"]}
              src={`${process.env.IMAGE_DOMAIN}/home/csotd-clock.png`}
              alt="clock"
              width={"34"}
              height={"31"}
            />
            
            <div className={styles["count-down-content"]}>
              <div className={styles["count-down-number"]}>
                <div className={styles['hh']}>
                  <span className={styles['h']}>{timeDetail[0]}&nbsp;{timeDetail[1]}</span>
                </div>
                <b>:</b>
                <div className={styles['ss']}>
                  <span className={styles['s']}>{timeDetail[2]}&nbsp;{timeDetail[3]}</span>
                </div>
                <b>:</b>
                <div className={styles['mm']}>
                  <span className={styles['s']}>{timeDetail[4]}&nbsp;{timeDetail[5]}</span>
                </div>
              </div>

              <div className={styles["count-desc"]}>
                24 hours only! Don&apos;t Miss Out
              </div>
            </div>
          </div>

          <div 
            className={styles["product-name"]}
            onClick={() => handleViewDetail(crazyDealData?.url || '')}
          >{crazyDealData?.name}</div>

          <div className={styles['price-desc']}>
            <div className={styles['price']}>
              <span>${priceArr[0]}.<i>{priceArr[1]}</i></span>
            </div>
            <div className={styles['marking-price']}>
              <span>${crazyDealData?.normalPrice}</span>
            </div>
          </div>

          <div 
            className={styles["grab-now"]}
            onClick={(event) => handleGrabNow(event)}
          >Grab It Now!</div>
        </div>

        <Image
          className={styles["product-image"]}
          src={crazyDealData?.filename || ''}
          onClick={() => handleViewDetail(crazyDealData?.url || '')}
          alt="csotd"
          width={"155"}
          height={"155"}
        />
      </div>
      ) : <Skeleton rowHeight={14}></Skeleton>}

      {
        crazyDealData?.promotion && crazyDealData.promotion.promotionRate ? (
          <div 
            className={styles['promotion-rate-box']}
            style={{ 
              background: `url('${process.env.IMAGE_DOMAIN}/home/csotd-promotion-bg.svg') no-repeat`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              }}
          >
            <div className={styles['promotion-rate-number']}>
              {crazyDealData.promotion.promotionRate}%
            </div>
            <div className={styles['promotion-rate-text']}>OFF</div>
          </div>
        ) : null
      }
    </div>
  );
}
